// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HomeNavController from "./home_nav_controller"
application.register("home-nav", HomeNavController)


import PhotoswipeController from "./photoswipe_controller"
application.register("photoswipe", PhotoswipeController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)

import ReviewsCarouselController from "./reviews_carousel_controller"
application.register("reviews-carousel", ReviewsCarouselController)
